<div [id]="idModal" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Alterar senha <span *ngIf="nomeUsuario">de {{nomeUsuario}}</span>
                </h4>        
            </div>
            <div class="modal-body">
               <form #form="ngForm" novalidate>
                   <div class="row">
                       <div class="form-group col-12">
                           <label for="novaSenha" class="col-form-label">Senha</label>
                           <input type="password" class="form-control" [(ngModel)]="entity.senha" name="novaSenha" id="novaSenha"
                            #novaSenha="ngModel" required="required" maxlength="100" placeholder="Informe a nova senha">
                            <sgt-form-control-error
                                *ngIf="novaSenha.errors && novaSenha.errors.required && novaSenha.dirty"
                                msgError="É necessário informar a nova senha">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="novaSenha.errors && novaSenha.errors.maxlength"
                                msgError="A senha deve ter no máximo 100 caracteres">
                            </sgt-form-control-error>                              
                       </div>
                   </div>
               </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="alterar()" id="btnAlterarSenha" [disabled]="form.invalid">
                    Alterar
                </button>
                <button type="button" class="btn btn-light" (click)="close()">
                    Não alterar
                </button>
            </div>            
        </div>
    </div>
</div>